import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../generic';
import List from '../../generic/List';
import Toggle from '../../generic/Toggle';
import Tooltip from '../../generic/Tooltip';

import styles from './LicensePolicySettingsPage.module.less';

type Props = {
  label: string;
  description: string;
  onChange: (value: boolean) => void;
  initialValue?: boolean;
  currentValue?: boolean;
  isDisabled?: boolean;
  disabledTooltip?: string;
  isLoading: boolean;
  subtitle?: string;
};

const LicensePolicySettingItem: VoidFunctionComponent<Props> = ({
  label,
  description,
  onChange,
  initialValue = false,
  currentValue,
  isDisabled = false,
  disabledTooltip,
  isLoading,
  subtitle,
}) => {
  const isToggledOn = currentValue ?? initialValue;

  const handleToggle = (value: boolean) => {
    if (isDisabled) {
      return;
    }
    onChange(value);
  };

  const handleRowClick = () => {
    if (isDisabled) {
      return;
    }
    const willBeChecked = !isToggledOn;
    handleToggle(willBeChecked);
  };

  return (
    <Tooltip id={`${label}-tooltip`} tooltip={disabledTooltip} showTooltip={isDisabled}>
      <div className={`${styles.setting} ${isDisabled ? styles.disabled : ''}`}>
        <List.Row
          right={
            isLoading ? (
              <Icon icon={icons.circleO} hasSpin />
            ) : (
              <Toggle checked={isToggledOn} onChange={handleToggle} isDisabled={isDisabled} />
            )
          }
          isInteractive={!isDisabled && !isLoading}
          onClick={handleRowClick}
        >
          <List.RowTitle>{label}</List.RowTitle>
          {subtitle && <List.RowSubtitle>{subtitle}</List.RowSubtitle>}
          <List.RowDetails>
            <div className={styles.settingsRowDetail}>{description}</div>
          </List.RowDetails>
        </List.Row>
      </div>
    </Tooltip>
  );
};

export default LicensePolicySettingItem;
